import UserTags from './UserTags'

export default UserTags
// eslint-disable-next-line import/export
export * from './UserTags'
